import Config from '@config';
import { initializeAddressesApi } from '@gasbi/shared';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export interface AddressDetailsModel {
  id: string;
  settlementId: string;
  streetId: string;
  settlement: string;
  street: string;
  oldStreet: string;
  streetType: string;
  settlementType: string;
  buildingNumber: string;
  region?: string | null;
  district?: string | null;
  community?: string | null;
  postalCode?: string | null;
  fullAddress: string;
}

const addressesApiObject = initializeAddressesApi({
  baseUrl: Config.VITE_API_CLIENT_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  addressesApi,
  useGetBuildingNumbersQuery,
  useGetSettlementsIInfiniteQuery,
  useGetStreetIInfiniteQuery,
} = addressesApiObject;

const extendedAddressesApi = addressesApi.injectEndpoints({
  endpoints: builder => ({
    getAddressById: builder.query<AddressDetailsModel, string>({
      query: id => ({ url: `${id}`, method: 'GET' }),
    }),
  }),
});

export const { useGetAddressByIdQuery } = extendedAddressesApi;
